module.exports = __webpack_public_path__ + "img/home-logo.fd07f99f.png";